import Form from '../forms/Form' 
import './reserva.css'

const Reserva = () => {
    return (
      <div className="customBackground">
          <h2>ZORRO CON BOTAS RESERVA</h2>
          <h4>Aquí podrás hacer tus reservas próximamente, por ahora puedes envíanos un mensaje </h4>
          <br></br>
          <p><Form /></p>
          <h4>También nos puedes llamar o enviar un correo</h4>
      </div>
    )
  
  }
  
  export default Reserva;